module.exports = __webpack_public_path__ + "static/media/pause.ec7d4dd0.svg";